import { checkPermission } from "@utils/user-permissions";

export const paths = {
  index: "/",
  unauthorized: "/unauthorized",
  vesselCall: {
    index: "vessel-call",
    create: "create",
    vesselScan: "vessel-scan",
    scanResults: "scan-results",
    preArrivalNotification: "pre-arrival-notification",
    imoFAL: "imo-fal",
    additionalDocuments: "additional-documents",
    vesselCallStatus: "vessel-call-status/:id",
    vesselCallPreview: "vessel-call-status", //used in the port services page navigation
    vesselDetails: "vessel-details",
    movementServices: "movement-services",
    addMovementService: "add-movement-service",
    movementService: "movement-service",
    portServices: "port-services",
    operations: {
      index: "operations",
      disputes: "disputes",
    },
    departure: "departure",
    shippingAgencyTransfer: "shipping-agency-transfer",
    addPortService: "add-port-service",
  },
  licenses: {
    index: "license",
    accountIndex: "accounts",
    portOperatorIndex: "port-operator-licenses",
    licenseDetailsById: "license-details/:id",
    licenseDetails: "license-details",
    portOperatorLicenseRequest: "port-operator-license-request",
    vendorLicenseRenewal: "vendor-license-renewal/:renewalId",
    portOperatorLicenseRenewal: "port-operator-license-renewal/:renewalId",
  },
  portServices: {
    index: "port-services",
  },
  vesselManagement: {
    index: "vessel-management",
    vesselStatus: "vessel-status/:id",
    register: "register",
    vesselInformation: "vessel-information",
    vesselType: "vessel-particulars",
    vesselOwnership: "vessel-ownership",
    vesselCertificates: "vessel-certificates",
    additionalDocuments: "additional-documents",
    bunkerBarge: "bunker-barge",
  },
  movementServices: {
    index: "movement-services",
  },
  portSecurity: {
    index: "port-security",
    clearances: "clearances",
    requestSecurityClearance: "request-security-clearance",
    clearanceForm: "clearance-form",
    personalInfo: "personal-info",
    socialInfo: "social-info",
    occupationInfo: "occupation-info",
    securityClearanceApplication: "security-clearance-application",
    securityClearanceRequestPreview: "security-clearance-request-preview",
    checkId: "check-id",
  },
  gatepass: {
    index: "gatepass",
    gatepasses: "gatepasses",
    gatepassRequestPreview: "gatepass-request-preview",
    requestGatepass: "request-gatepass",
    normalGatepass: "/gatepass/request-gatepass/normal",
    offshoreGatepass: "/gatepass/request-gatepass/offshore",
    truckGatepass: "/gatepass/request-gatepass/truck",
    cargoGatepass: "/gatepass/request-gatepass/cargo",
  },
  notifications: "notifications",
  settings: "settings",
  vendorLicenseRequest: "/marhub-account-request",
  vendorLicenseRequestConfirmation: "/marhub-account-request/confirmation",
  checkSecurityClearance: "/check-security-clearance",
};

export const AppNavigationItems = (
  userAccessPermissions: string[],
  location: string,
  customPath: string | null,
) => {
  const isLicensesActive =
    location?.includes(paths.licenses.index) ||
    location?.includes(paths.licenses.accountIndex) ||
    location?.includes(paths.licenses.portOperatorIndex);

  return [
    {
      title: "Dashboard ",
      path: "/",
      testId: "dashboard-button",
      isVisible: false,
      isActive: null,
    },
    {
      title: "Vessel Call Management",
      path: paths.vesselManagement.index,
      isActive:
        location?.includes(paths.vesselCall.index) ||
        location?.includes(paths.vesselManagement.index) ||
        location?.includes(paths.portServices.index) ||
        location?.includes(paths.movementServices.index),
      isVisible:
        checkPermission(userAccessPermissions, "hasVesselRegistrationAccess") ||
        checkPermission(userAccessPermissions, "hasVesselCallAccess"),
      testId: "vesselManagement-button",
      submenu: [
        {
          title: "Vessel Call",
          path: paths.vesselCall.index,
          testId: "vesselCall-submenuButton",
          isActive: null,
          isVisible: checkPermission(userAccessPermissions, "hasVesselCallAccess"),
        },
        {
          title: "Vessel Management",
          path: paths.vesselManagement.index,
          testId: "vesselManagement-submenuButton",
          isActive: null,
          isVisible: checkPermission(userAccessPermissions, "hasVesselRegistrationAccess"),
        },
        {
          title: "Port Services",
          path: paths.portServices.index,
          isActive: null,
          testId: "portServices-button",
          isVisible: checkPermission(userAccessPermissions, "hasVesselCallAccess"), //to add the right permissions
        },
        {
          title: "Movement Services",
          path: paths.movementServices.index,
          testId: "movementServices-submenuButton",
          isActive: null,
          isVisible: checkPermission(userAccessPermissions, "hasVesselCallAccess"),
        },
      ],
    },
    {
      title: "Security Clearance",
      isActive: location?.includes(paths.portSecurity.index),
      path: customPath || paths.portSecurity.index,
      testId: "portSecurity-button",
      isVisible:
        checkPermission(userAccessPermissions, "hasSecurityClearanceAccess") ||
        checkPermission(userAccessPermissions, "hasSecurityClearanceRequestAccess"),
    },
    {
      title: "Gatepass",
      path: paths.gatepass.index,
      isActive: location?.includes(paths.gatepass.index),

      testId: "gatepass-button",
      isVisible: checkPermission(userAccessPermissions, "hasGatepassAccess"),
    },
    {
      title: "Licenses",
      path: paths.licenses.index,
      testId: "licenses-button",
      isActive: isLicensesActive,
      isVisible:
        checkPermission(userAccessPermissions, "hasCustomerLicenseAccess") &&
        checkPermission(userAccessPermissions, "hasPortOperatorLicenseAccess") &&
        checkPermission(userAccessPermissions, "hasVendorLicenseAccess"),
    },
  ];
};
